import * as React from 'react';

const SendOrderSuccess: React.FunctionComponent = () => {
  return <div>We've added your Custom Made map to your basket.</div>;
};

export default SendOrderSuccess;
